import React from 'react';

function AlertMessage({ error, success }) {
  return (
    <>
      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}
    </>
  );
}

export default AlertMessage;
